"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Overview = babelHelpers.interopRequireWildcard(require("tab/Overview"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var VirtualEventOverviewTab = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(VirtualEventOverviewTab, _Component);

  function VirtualEventOverviewTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VirtualEventOverviewTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VirtualEventOverviewTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "locationTitle", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "address", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "description", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "people", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(VirtualEventOverviewTab, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "objectBodyTab"
      }, React.createElement("div", {
        className: "stack text two-column"
      }, React.createElement("div", {
        className: "container"
      }, React.createElement("div", {
        className: "inner-content"
      }, this.description && React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.description
        }
      }), this.people && React.createElement(_Overview.PeopleList, this.people)))));
    }
  }], [{
    key: "value",
    value: function value(object, page, tab) {
      var pp = _Overview.default.getPeople(object, page, tab);

      if (!pp.people || !object.description) {
        return null;
      }

      var order = tab.order,
          title = tab.title,
          includeDiscussion = tab.includeDiscussion,
          id = tab.id;
      return {
        type: 'tab/VirtualEventOverviewTab',
        description: object.description,
        people: pp
      };
    }
  }]);
  return VirtualEventOverviewTab;
}(Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "locationTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "address", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = VirtualEventOverviewTab;